import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from '@material-ui/core/styles';
const InputComponent = ({ inputRef, ...other }) => <div {...other} />;
const useStyles = makeStyles((theme) => ({
    outlinedDiv: {
        width: '100%',
        background: '#f2f2f2 !important',
    }
}));
const OutlinedDiv = ({ children, label }) => {
    const classes = useStyles();
    return (
        <TextField
            variant="outlined"
            className={classes.outlinedDiv + ' outlinedDiv'}
            label={label}
            multiline
            InputLabelProps={{ shrink: true }}
            InputProps={{
                inputComponent: InputComponent
            }}
            inputProps={{ children: children }}
        />
    );
};
export default OutlinedDiv;
